<template>
	<div class="option-wrapper">
		<div class="label">{{ label }}</div>
		<div class="field">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OptionWrapper',
	props: {
		label: { type: String },
		fieldIdentifier: { type: Object },
	},
	watch: {
		fieldIdentifier: {
			handler(newV) {
				this.localModel = newV;
			},
			immediate: true,
		},
		localModel: {
			handler(newV) {
				this.$emit('update:fieldIdentifier', newV);
			},
		},
	},
	data() {
		return {
			localModel: false,
		};
	},
};
</script>

<style scoped lang="scss">
.option-wrapper {
	.label {
		margin: 3px 0 3px 0;
	}
	.field {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 3px 0 3px 0;
	}
}
</style>
